import { Link } from "react-router-dom";
import { Lightning } from "@phosphor-icons/react";
import { PREORDER_MODE, PREORDER_NOTE } from "@/lib/siteConfig";

export default function PreorderBanner() {
  if (!PREORDER_MODE) return null;
  return (
    <Link to="/shop" data-testid="preorder-banner"
      className="block w-full text-center text-xs sm:text-sm py-2 px-4 text-black font-modern font-semibold tracking-wide hover:opacity-90 transition-opacity"
      style={{ background: "linear-gradient(90deg,#ff1493,#ccff00)" }}>
      <span className="inline-flex items-center gap-2 justify-center">
        <Lightning weight="fill" size={14} /> {PREORDER_NOTE}
      </span>
    </Link>
  );
}
